import React, { useContext } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { ConversionDataContext } from './conversion-data-context';

/** Conversion Tracking Tag data HOC and wrapper to manage all Tag related
 * data and data operations. This abstracts all the data context references
 * into HOC and wraps a pure UI view component.
*/

export const withConversionTagData = (WrappedComponent) => {
  const HOC = (props) => {
    const { tagContext } = useContext(ConversionDataContext);

    return (
      <WrappedComponent
        tagContext={tagContext}
        {...props}
      />
    );
  };

  HOC.displayName = `withConversionTagData(${getDisplayName(WrappedComponent)})`;
  hoistNonReactStatics(HOC, WrappedComponent);

  return HOC;
};
